import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavMenu } from '../nav-menu/nav-menu';

@Component({
  selector: 'app-key-contacts',
  templateUrl: './key-contacts.html',
  styleUrls: ['./key-contacts.css'],
  imports: [NavMenu],
})
export class KeyContacts implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
